import React, { useState } from 'react'
import {Button,Modal} from 'react-bootstrap'

function ModalEquipmentMaterial () {
    
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <div>
            <Button variant="primary" onClick={handleShow}>
                Learn more
            </Button>
            {/* <a href="/" className="btn btn-link right-icon" >Learn more <i className="icon icon-minimal-right"></i></a> */}
    
            <Modal show={show} onHide={handleClose} animation={false}>
            <Modal.Header closeButton>
                <Modal.Title>Equipment & Material Management in Construction Project</Modal.Title>
            </Modal.Header>
            <Modal.Body>Solusi tentang utilitasi tools dan material in construction. 
                Termasuk diantaranya monitoring material losses, efisiensi alat, dan pengelolaan bekisting (framework).
            </Modal.Body>
                <Modal.Footer>
                    <a 
                    style={{"color":"#fff"}}
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.youtube.com/watch?v=SFdSXHMt5Tg">
                        <button className="btn btn-primary" >
                            Keynotes Video
                        </button>
                    </a>
                </Modal.Footer>
            </Modal>
        </div>
    );
}


export default ModalEquipmentMaterial
